@switch (template) {
<!-- Change language tooltip -->
@case ('language') {
<div
  class="language"
  i18n="
    Label| Content of the change language tooltip@@tooltipChangeLanguageLabel"
>
  Changer de langue
</div>
}
<!-- Tooltips triggered by the dashboard cards -->
@case ('breakdown') {
<div
  @tooltip
  class="breakdown"
  i18n="
    Label | Content of the tooltip for the card breakdown@@tooltipBreakdownLabel"
>
  Indique le fonctionne-ment normal des instal-lations sur la période
  considérée. Évalué 24h/24 et 7j/7.
</div>
} @case ('rogue-units-card') {
<div
  @tooltip
  class="rogue-unit"
  i18n="
    Label | Content of the tooltip for the card rogue
    units@@tooltipRogueUnitsLabel"
>
  Appareils ayant au moins 2 interventions pour matériel défectueux au cours des
  30 derniers jours.
</div>
} @case ('availability') {
<div
  @tooltip
  class="availability"
  i18n="
    Label | Content of the tooltip for the card
    availability@@tooltipAvailabilityLabel"
>
  Pourcentage du temps couvert par le contrat pendant lequel les appareils ont
  été fonctionnels.
</div>
} @case ('devicesConditions') {
<div
  @tooltip
  class="devices-conditions"
  i18n="
    Label | Content of the tooltip for the card devices
    conditions@@tooltipDevicesConditionsLabel"
>
  L'état des appareils indique le nombre d'ascenseurs à l'arrêt et le nombre
  d'ascenseurs fonctionnels.
</div>
} @case ('callouts') {
<div
  @tooltip
  class="callouts"
  i18n="
    Label | Content of the tooltip for the card callouts@@tooltipCalloutsLabel"
>
  Ce graphe prend en compte les pannes et les passagers bloqués.
</div>
} @case ('visits') {
<div
  @tooltip
  class="visits"
  i18n="Label | Content of the tooltip for the card visits@@tooltipVisitsLabel"
>
  Ce graphe prend en compte toutes les visites réglementées effectuées.
</div>
} @case ('maintenances') {
<div
  @tooltip
  class="maintenances"
  i18n="
    Label | Content of the tooltip for the card
    maintenances@@tooltipMaintenancesLabel"
>
  Ce graph prend en compte toutes les visites réglementées.
</div>
} @case ('auditReportsCard') {
<div
  @tooltip
  class="audit-reports-card"
  i18n="
    Label | Content of the tooltip for the admin dashboard audit reports
    card@@tooltipAuditReportsCardLabel"
>
  Répartition des réserves existantes selon leur statut.
</div>
} @case ('auditReportsResolutionCard') {
<div
  @tooltip
  class="audit-reports-resolution-card"
  i18n="
    Label | Content of the tooltip for the admin dashboard audit reports
    resolution card@@tooltipAuditReportsResolutionCardCardLabel"
>
  Nombre de réserves levées par mois.
</div>
} @case ('finances') {
<div
  @tooltip
  class="finances"
  i18n="
    Label | Content of the tooltip for the card fincances@@tooltipFinancesLabel"
>
  Coût des contrats de maintenance (prix an-nuels des contrats) et coût des
  travaux d'amélioration ayant donné lieu à un devis validé (depuis le 1er
  janvier).
</div>
} @case ('deadlines') {
<div @tooltip class="deadlines">
  <p
    i18n="
      Label | Content of the headline tooltip for the card
      deadlines@@tooltipDeadlinesHeadlineLabel"
  >
    Le respect des délais est calculé selon les délais contractuels ou, à
    défaut, réglementaires.
  </p>
  <p
    class="list-title"
    i18n="
      Label | Label details in tooltip of deadlines card@@tooltipDeadlinesLabel"
  >
    Vos délais :
  </p>
  <ul>
    <li
      i18n="
        Label | Content of the tooltip for the detail visit
        frequency@@tooltipDeadlinesDetailVisitFrequencyLabel"
    >
      Visites régulières : [visit frequency]
    </li>
    <li
      i18n="
        Label | Content of the tooltip for the detail visit
        semiannual@@tooltipDeadlinesDetailVisitSemiannualLabel"
    >
      Visites semi-annuelles : 6 mois
    </li>
    <li
      i18n="
        Label | Content of the tooltip for the detail visit
        annual@@tooltipDeadlinesDetailVisitAnnualLabel"
    >
      Visites annuelles : 1 an
    </li>
  </ul>
</div>
} @case ('iot-building') {
<div
  @tooltip
  class="iot-building"
  i18n="
    Label | Content of the tooltip for the card iot@@tooltipIotBuildingLabel"
>
  Cette adresse est équipé d'un dispositif IoT
</div>
} @case ('iot-device') {
<div
  @tooltip
  class="iot-device"
  i18n="Label | Content of the tooltip for the card iot@@tooltipIotDeviceLabel"
>
  Cet appareil est équipé d'un dispositif IoT
</div>
} @case ('reserves') {
<div @tooltip class="reserves"></div>
} @case ('iot') {
<div @tooltip class="iot"></div>
} @case ('invoices') {
<div @tooltip class="invoices"></div>
}
<!-- Tooltips triggered by the data dashboard cards -->
@case ('floor-usage') {
<div
  @tooltip
  class="floor-usage"
  i18n="
    Label | Content of the tooltip for the card floor
    usage@@tooltipfloorUsageLabel"
>
  Les étages les plus desservis indiquent le nombre de trajets qui commencent ou
  se terminent à l'étage indiqu
</div>
} @case ('peak-hours') {
<div
  @tooltip
  class="peak-hours"
  i18n="
    Label | Content of the tooltip for the card peak
    hours@@tooltipPeakhoursLabel"
>
  La fréquentation indique le nombre de trajets totaux par tranche horaire
</div>
} @case ('peak-days') {
<div
  @tooltip
  class="peak-days"
  i18n="
    Label | Content of the tooltip for the card peak days@@tooltipPeakDaysLabel"
>
  La fréquentation par jour indique le nombre de trajets moyen par jour de la
  semaine
</div>
} @case ('floor-to-floor') {
<div
  @tooltip
  class="floor-to-floor"
  i18n="
    Label | Content of the tooltip for the card floor to
    floor@@tooltipFloorToFloorLabel"
>
  Les étages qui communiquent le plus indiquent le nombre de trajets entre deux
  étages sur les 30 derniers jours (les trajets du RDC ou inférieurs ne sont pas
  inclut)
</div>
} @case ('most-used-lifts') {
<div
  @tooltip
  class="most-used-lifts"
  i18n="
    Label | Content of the tooltip for the card
    most-used-lifts@@tooltipMostUsedLiftsLabel"
>
  Le nombre de trajets total sur les 30 derniers jours.
</div>
}
<!-- Tooltip triggered by the download button in device intervention row -->
@case ('download-report') {
<div
  @tooltip
  class="download-report"
  i18n="
    Label | Content of the tooltip download report@@tooltipDownloadReportLabel"
>
  Télécharger le rapport
</div>
}
<!-- Tooltip triggered by the download button in device intervention row in case of a fire alarm device -->
@case ('sidebar-firealarm-reports') {
<div
  @tooltip
  class="sidebar-firealarm-reports"
  i18n="
    Label | Content of the tooltip sidebar firealarm
    reports@@tooltipSidebarFirealarmReportsLabel"
>
  Voir le rapport et les bons d'interventions
</div>
} @case ('delete-report') {
<div
  @tooltip
  class="delete-report"
  i18n="Label | Content of the tooltip delete report@@tooltipDeleteReportLabel"
>
  Supprimer le rapport
</div>
}
<!-- Tooltip triggered by the download button in admin audit defect details fixed row -->
@case ('download-certificate') {
<div
  @tooltip
  class="download-certificate"
  i18n="
    Label | Content of the tooltip download
    certificate@@tooltipDownloadCertificateLabel"
>
  Télécharger l'attestation de levée de réserve
</div>
}
<!-- Tooltip triggered by the maximize indicator button when user don't have maximize -->
@case ('no-maximize-access') {
<div
  @tooltip
  class="no-maximize-access"
  i18n="
    Label | Content of the tooltip no maximize
    access@@tooltipNoMaximizeAccessLabel"
>
  Si vous souhaitez voir cette donnée, vous devez souscrire à notre offre
  Maximize
</div>
}
<!-- Tooltip triggered by the hovering of the upload quotes button -->
@case ('upload-quotes') {
<div
  @tooltip
  class="upload-quotes"
  i18n="Label | Content of the tooltip upload quotes@@tooltipUploadQuotesLabel"
>
  Envoyer un ordre de service / devis signé
</div>
}
<!-- Tooltip triggered by hovering the quotes info icon -->
@case ('info-to-sign-quotes') {
<div
  @tooltip
  class="info-to-sign-quotes"
  i18n="
    Label | Content of the tooltip info to sign
    quotes@@tooltipInfoToSignQuotesLabel"
>
  <p class="title">1 Action à faire</p>
  <p>Nous attendons un retour votre part sur ce devis</p>
</div>
} @case ('delete-mission') {
<div
  @tooltip
  class="delete-mission"
  i18n="Label| Content of the tooltip delete mission@@tooltipDeleteMission"
>
  Supprimer la mission
</div>
} @case ('delete-task') {
<div
  @tooltip
  class="delete-task"
  i18n="Label| Content of the tooltip delete task@@tooltipDeleteTask"
>
  Supprimer la tâche
</div>
} @case ('link-task') {
<div @tooltip class="link-task" i18n="@@tooltipLinkTask">Lier la tâche</div>
}
<!-- Operations monitoring tooltip -->
@case ('operations-monitoring') {
<div
  class="operations-monitoring"
  i18n="
    Label | Content of operations monitoring
    tooltip@@tooltipOperationsMonitoringLabel"
>
  Activités
</div>
}
<!-- Operations monitoring tooltip about mission -->
@case ('mission-infos') {
<div
  class="mission-infos"
  i18n="Label | Content of the mission infos tooltip@@tooltipMissionInfosLabel"
>
  Infos mission
</div>
}
<!-- Operations monitoring tooltip about engineer edition -->
@case ('engineer-edition') {
<div
  class="engineer-edition"
  i18n="
    Label | Content of the engineer edition tooltip@@tooltipEngineerEditionLabel"
>
  Modifier le technicien
</div>
} @case ('mission-not-done') {
<div
  class="mission-not-done"
  i18n="
    Label | Content of the mission not done tooltip@@tooltipMissionNotDoneLabel"
>
  <p>Au moins une tâche a déjà été commencée</p>
</div>
}
<!-- Operations monitoring tooltip -->
@case ('devices') {
<div
  class="device"
  i18n="Label | Content of devices tooltip@@tooltipUnitsLabel"
>
  Appareils
</div>
}
<!-- Preview photos tooltip -->
@case ('preview-photos') {
<div
  class="preview-photos"
  i18n="
    Label | Content of the picture preview tooltip@@tooltipPreviewPhotosLabel"
>
  Aperçu des photos
</div>
}
<!-- Preview photos tooltip disabled -->
@case ('preview-photos-disabled') {
<div
  class="preview-photos-disabled"
  i18n="
    Label | Content of the picture preview disabled
    tooltip@@tooltipPreviewPhotosDisabledLabel"
>
  Aucune photo
</div>
}
<!-- Billing tooltip -->
@case ('billing') {
<div
  class="billing"
  i18n="Label | Content of the billing tooltip@@tooltipBillingLabel"
>
  Facturation
</div>
}
<!-- Audit tooltip -->
@case ('audit') {
<div
  class="audit"
  i18n="Label | Content of the audit tooltip@@tooltipAuditLabel"
>
  Réserves
</div>
}
<!-- Overtime tooltip -->
@case ('overtime') {
<div
  class="overtime"
  i18n="Label | Content of the overtime tooltip@@tooltipOvertimeLabel"
>
  Overtime
</div>
}
<!-- Contact tooltip -->
@case ('contact') {
<div
  class="contact"
  i18n="Label | Content of the contact tooltip@@tooltipContactLabel"
>
  Contact
</div>
}
<!-- Maximize tooltip -->
@case ('maximize') {
<div
  class="maximize"
  i18n="Label | Content of the maximize tooltip@@tooltipMaximizeLabel"
>
  Maximize
</div>
}
<!-- Dashboard tooltip -->
@case ('dashboard') {
<div
  class="dashboard"
  i18n="Label | Content of the dashboard tooltip @@tooltipDashboardLabel"
>
  Tableau de bord
</div>
}
<!-- Access time tooltip -->
@case ('move-to-invoice') {
<div
  class="invoice"
  i18n="Label| Content of the invoice tooltip@@tooltipInvoiceLabel"
>
  Mettre à facturer
</div>
}
<!-- Deny tooltip -->
@case ('deny') {
<div class="deny" i18n="Label | Content of the deny tooltip @@tooltipDenyLabel">
  Refuser
</div>
}
<!-- Accept tooltip -->
@case ('accept') {
<div
  class="accept"
  i18n="Label| Content of the accept tooltip@@tooltipAcceptLabel"
>
  Accepter
</div>
}
<!-- customers tooltips -->
@case ('link-to-client-platform') {
<div
  class="link-to-client-platform"
  i18n="
    Label| Content of the link to client platform
    tooltip@@tooltipLinkToClientPlatformLabel"
>
  Accès à la plateforme client
</div>
} @case ('link-to-client-platform-denied') {
<div
  class="link-to-client-platform"
  i18n="
    Label| Content of the link to client platform
    tooltip@@tooltipLinkToClientPlatformDeniedLabel"
>
  Pas d’accès à la plateforme client
</div>
} @case ('customers-admin-nav') {
<div
  class="link-to-client-platform"
  i18n="Label| Content of the customers nav tooltip@@tooltipCustomersNavLabel"
>
  Contacts
</div>
} @case ('reports-admin-nav') {
<div
  class="link-to-client-platform"
  i18n="Label| Content of the reports nav tooltip@@tooltipReportsNavLabel"
>
  Bilans
</div>
} @case ('iot-admin-nav') {
<div
  class="link-to-client-platform"
  i18n="Label| Content of the iot nav tooltip@@tooltipIotNavLabel"
>
  IoT
</div>
} @case ('address') {
<div
  class="address"
  i18n="Label | Content of documents tooltip@@tooltipAddressLabel"
>
  Adresses
</div>
} @case ('documents') {
<div
  class="documents"
  i18n="Label | Content of documents tooltip@@tooltipDocumentsLabel"
>
  Documents
</div>
}
<!-- Tooltip triggered by the contract link button in the admin device onboarding screen -->
@case ('contract-link') {
<div
  @tooltip
  class="download-report"
  i18n="Label | Content of the tooltip contract link@@tooltipContractLinkLabel"
>
  Lien vers le contrat
</div>
}
<!-- Tooltip triggered by the tco graph title -->
@case ('tco') {
<div
  @tooltip
  class="tco"
  i18n="Label | Content of the tooltip tco graph tooltip@@tooltipTcoGraphLabel"
>
  Tous les coûts en lien avec le service de maintenance de WeMaintain
</div>
}
<!-- Tooltip triggered by the tco yearly graph title -->
@case ('tco-yearly-card') {
<div
  @tooltip
  class="tco-yearly-card"
  i18n="
    Label | Content of the tooltip tco yearly graph
    tooltip@@tooltipTcoYearlyGraphLabel"
>
  Tous les coûts en lien avec le service de maintenance de WeMaintain
</div>
}
<!-- Tooltip triggered by the esg graph title -->
@case ('esg') {
<div
  @tooltip
  class="esg"
  i18n="Label | Content of the tooltip esg graph tooltip@@tooltipEsgGraphLabel"
>
  Moyenne de la consommation énergétique des 30 derniers jours
</div>
}
<!-- Tooltip triggered by the esg graph title -->
@case ('esg-by-month') {
<div
  @tooltip
  class="esg-by-month"
  i18n="
    Label | Content of the tooltip esg by month graph
    tooltip@@tooltipEsgByMonthGraphLabel"
>
  Total de la consommation énergétique des 13 derniers mois
</div>
}
<!-- Tooltip triggered by the esg costs graph title -->
@case ('esg-costs') {
<div
  @tooltip
  class="esg-costs"
  i18n="
    Label | Content of the tooltip esg by month graph
    tooltip@@tooltipEsgCostsGraphLabel"
>
  Coût de la consommation énergétique sur 13 derniers mois
</div>
}
<!-- Tooltip triggered by the esg by device type graph title -->
@case ('esg-by-device-type') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip esg by device type graph
    tooltip@@tooltipEsgByDeviceTypeGraphLabel"
>
  Classement des équipements qui ont consommé le plus d'énergie sur les 30
  derniers jours.
</div>
}
<!-- Tooltip triggered by the comparator availability graph title -->
@case ('comparator-availability') {
<div
  class="comparator-availability"
  i18n="
    Label| Content of the comparator availability
    tooltip@@tooltipComparatorAvailabilityLabel"
>
  Pourcentage du temps couvert par le contrat pendant lequel les appareils ont
  été fonctionnels.
</div>
}
<!-- Tooltip triggered by the comparator cost graph title -->
@case ('comparator-cost') {
<div
  class="comparator-cost"
  i18n="
    Label| Content of the comparator cost tooltip@@tooltipComparatorCostLabel"
>
  Coûts mensuels sur les 13 derniers mois
</div>
}
<!-- Tooltip triggered by the comparator energy graph title -->
@case ('comparator-energy') {
<div
  class="comparator-energy"
  i18n="
    Label| Content of the comparator energy
    tooltip@@tooltipComparatorEnergyLabel"
>
  Consommation énergétique sur les 13 derniers mois
</div>
}
<!-- Tooltip triggered by the comparator trips graph title -->
@case ('comparator-trips') {
<div
  class="comparator-trips"
  i18n="
    Label| Content of the comparator trips tooltip@@tooltipComparatorTripsLabel"
>
  Nombre de trajets sur les 13 derniers mois
</div>
}
<!-- Tooltip triggered by the repair nav item -->
@case ('repair') {
<div
  class="comparator-trips"
  i18n="Label| Content of the repair tooltip@@tooltipRepairLabel"
>
  Demande de réparation
</div>
} @case ('assign-part') {
<div
  class="assign-part"
  i18n="Label | Content of the tooltip assign part@@tooltipAssignPartLabel"
>
  Assigner pièce
</div>
}
<!-- Tooltip triggered by the actions delete in admin iot things -->
@case ('delete-partnership-thing') {
<div
  @tooltip
  class="delete-partnership-thing"
  i18n="
    Label | Content of the tooltip delete
    partnership@@tooltipDeletePartnershipLabel"
>
  Supprimer l'association
</div>
}
<!-- Tooltip triggered to add something -->
@case ('new-repair-request') {
<div
  @tooltip
  class="new-repair-request"
  i18n="
    Label | Content of the tooltip for the new engineer
    request@@tooltipNewEngineerRequestLabel"
>
  New engineer request
</div>
}
<!-- Tooltip for repair requests -->
@case ('see-opportunity') {
<div
  @tooltip
  class="see-opportunity"
  i18n="
    Label | Content of the tooltip for the see opportunity
    button@@tooltipSeeOpportunityRequestLabel"
>
  See opportunity on SF
</div>
} @case ('generate-quote') {
<div
  @tooltip
  class="generate-quote"
  i18n="
    Label | Content of the tooltip for quote
    generation@@tooltipGenerateQuoteLabel"
>
  Generate quote on SF
</div>
} @case ('see-details') {
<div
  @tooltip
  class="see-details"
  i18n="Label | Content of the tooltip for more details@@tooltipSeeDetailsLabel"
>
  See details
</div>
} @case ('see-netsuite') {
<div
  @tooltip
  class="see-netsuite"
  i18n="
    Label | Content of the tooltip for details on
    netsuite@@tooltipSeeNetsuiteLabel"
>
  See on Netsuite
</div>
} @case ('cancel-repair-request') {
<div
  @tooltip
  class="cancel-repair-request"
  i18n="
    Label | Content of the tooltip to cancel a repair
    request@@tooltipCancelRequestLabel"
>
  Annuler la demande
</div>
} @case ('force-repair-request-completion') {
<div
  @tooltip
  class="force-repair-request-completion"
  i18n="
    Label | Content of the tooltip to force a repair request
    completion@@tooltipForceRequestCompletionLabel"
>
  Marquer comme terminée
</div>
} @case ('forbidden-repair-request-action-cause-shutdown') {
<div
  @tooltip
  class="forbidden-repair-request-action-cause-shutdown"
  i18n="@@tooltipForbiddenRepairRequestActionCauseShutdown"
>
  Cette action n'est pas possible sur une demande de type "arrêt"
</div>
} @case ('unlink-intervention') {
<div
  @tooltip
  class="unlink-intervention"
  i18n="
    Label | Content of the tooltip to unlink an
    intervention@@tooltipUnlinkInterventionLabel"
>
  Annuler le lien
</div>
}
<!-- Assign mechanic -->
@case ('assign-tech') {
<div
  @tooltip
  class="assign-tech"
  i18n="
    Label | Content of the tooltip to assign
    mechanic@@tooltipAssignMechanicLabel"
>
  Assigner un expert
</div>
} @case ('assign-event') {
<div
  @tooltip
  class="assign-event"
  i18n="Label | Content of the tooltip to assign-event@@tooltipAssignEventLabel"
>
  Ajouter un évènement
</div>
} @case ('see-events') {
<div
  @tooltip
  class="assign-event"
  i18n="Label | Content of the tooltip to see-events@@tooltipSeeEventsLabel"
>
  Voir évènements
</div>
}
<!-- Overtime -->
@case ('validate-overtime') {
<div
  @tooltip
  i18n="Label | Content of the tooltip to accept@@tooltipAcceptOvertimeLabel"
>
  Accept overtime (You will be able to modify it before finalizing the process)
</div>
} @case ('deny-overtime') {
<div
  @tooltip
  i18n="Label | Content of the tooltip to see-events@@tooltipDenyOvertimeLabel"
>
  Deny overtime
</div>
} @case ('preapprover') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to
    see-events@@tooltipPreapproverOvertimeLabel"
>
  Selected preapprover
</div>
} @case ('reason-preapprover-not-selected') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to
    see-events@@tooltipReasonPreapproverNotSelectedOvertimeLabel"
>
  The reason why the preapprover was not selected
</div>
} @case ('visit-dates') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to see-events@@tooltipVisitDatesOvertimeLabel"
>
  The dates of visit and its duration
</div>
} @case ('to-be-paid') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to see-events@@tooltipToBePaidOvertimeLabel"
>
  Hours which will effectively be paid to the engineer
</div>
}
<!-- Cost -->
@case ('historical-prices') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to
    see-events@@tooltipHistoricalPricesCostLabel"
>
  Click "Edit cost" to see historical prices
</div>
} @case ('high-confidence') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to see-events@@tooltipHighConfidenceCostLabel"
>
  Past purchases were bought for around the same amount
</div>
} @case ('low-confidence') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip to see-events@@tooltipLowConfidenceCostLabel"
>
  There’s a big gap between prices, double-check before validating
</div>
} @case ('problem-explanation') {
<div @tooltip i18n="@@tooltipProblemExplanationLabel">
  A specific fault on a device: the component, plus what is wrong with it.
  Repair requests are raised to fix it.
</div>
} @case ('dilap-explanation') {
<div @tooltip i18n="@@tooltipDilapExplanationLabel">
  Found inside the contract dilap window. The fault pre-dates our contract.
</div>
} @case ('quote-other-costs') {
<div
  @tooltip
  i18n="
    Label | Content of the tooltip explaining the other costs of a quote
    margin@@tooltipQuoteOtherCostsLabel"
>
  Support, installation, etc. : tout ce qui n'est ni une pièce ni de la main
  d'œuvre (support technique, support réparation, installation, etc.)
</div>
}
<!-- Default tooltip -->
@default {
<div
  class="default"
  i18n="Label| Content of the default tooltip @@tooltipDefaultLabel"
>
  Unknown template
</div>
}
<!-- Standard tooltips -->
@case ('delete') {
<div
  @tooltip
  class="delete"
  i18n="Label | Content of the tooltip delete@@tooltipDeleteLabel"
>
  Supprimer
</div>
} @case ('edit') {
<div
  @tooltip
  class="edit"
  i18n="Label | Content of the tooltip edit@@tooltipEditLabel"
>
  Modifier
</div>
}
<!-- Tooltips for data -->
@case ('data') {
<div @tooltip class="data">
  @for (d of data; track d) {
  <p>
    @if (d) {
    {{ d }}
    }
  </p>
  }
</div>
} @case ('notifications') {
<div
  @tooltip
  class="notifications"
  i18n="Label | Content of the tooltip notifications@@tooltipNotificationsLabel"
>
  Notifications
</div>
} }
